import ButtonIcon from './ButtonIcon'

export default ButtonIcon



// WEBPACK FOOTER //
// ./src/components/ButtonIcon/index.js